import Button from '@mui/material/Button'
import { ButtonProps } from '@mui/material'
import { RcIcon } from '@/components/atoms/RcIcon'
import { RcTrans } from '@/components/atoms/RcTrans'

export const CreateButton = (props: ButtonProps) => {
  return (
    <Button
      className='create-team'
      variant='outlined'
      sx={{ color: 'primary.main' }}
      startIcon={<RcIcon icon={['fal', 'plus']} size='sm' />}
      {...props}
    >
      <RcTrans i18nKey='shared.create' />
    </Button>
  )
}
